import {LqdCarouselStackHandler} from './lqd-carousel-stack';

class LqdTestimonialCarouselStackHandler extends LqdCarouselStackHandler {

}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdTestimonialCarouselStackHandler, { $element } );
}; 